
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"
import cookies from "js-cookie"
import { ref } from "vue"

export default {
  props: ["active", "equipmentId", "position", "date"],
  setup(
    props: Record<
      "equipmentId" | "date" | "position" | "active",
      string | undefined
    >
  ) {
    const { t } = useI18n()
    const route = useRoute()
    let openId = route.query.openid?.toString() || null
    if (openId) {
      cookies.set("openId", openId) // 100年
    } else {
      openId = cookies.get("openId")?.toString() || null
    }
    const monthReportPath = ref("")
    // 基础路径
    let base = `/report/month/${props.equipmentId}`
    // 只有当 date 和 position 都存在且不为空字符串时，才拼接
    if (
      props.date &&
      props.position &&
      props.date !== "" &&
      props.position !== ""
    ) {
      base += `/${props.date}/${props.position}`
    }
    monthReportPath.value = base

    const dayReportPath = ref("")
    // 基础路径
    base = `/report/day/${props.equipmentId}`
    // 只有当 date 和 position 都存在且不为空字符串时，才拼接
    if (
      props.date &&
      props.position &&
      props.date !== "" &&
      props.position !== ""
    ) {
      base += `/${props.date}/${props.position}`
    }
    dayReportPath.value = base

    return { openId, monthReportPath, dayReportPath }
  }
}
